import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './soporte.css'

const Soporte = (props) => {
  return (
    <div className="soporte-container1">
      <Helmet>
        <title>
          Soporte - GESVET – App para digitalizar el trabajo veterinario en
          campo
        </title>
        <meta
          name="description"
          content="Solución móvil para veterinarios de ganado bovino. Registro de animales, estadísticas de preñez, revisación de toros e informes profesionales."
        />
        <meta
          property="og:title"
          content="Soporte - GESVET – App para digitalizar el trabajo veterinario en campo"
        />
        <meta
          property="og:description"
          content="Solución móvil para veterinarios de ganado bovino. Registro de animales, estadísticas de preñez, revisación de toros e informes profesionales."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/c5d5ed29-b3ec-4d24-824a-945896b13c65/a683aef5-7460-454d-aed7-588f9c14e5a7?org_if_sml=1&amp;force_format=original"
        />
        <link rel="canonical" href="https://www.gesvet.com.ar/soporte" />
        <meta property="og:url" content="https://www.gesvet.com.ar/soporte" />
      </Helmet>
      <Navigation></Navigation>
      <section className="support-section">
        <div className="support-container">
          <div className="support-split">
            <div className="support-info">
              <h2 className="section-title">Soporte y contacto</h2>
              <p className="section-content">
                ¿Necesitas ayuda con la configuración o tienes alguna duda
                técnica? Nuestro equipo está listo para asistirte.
              </p>
              <div className="contact-methods">
                <a href="https://wa.me/2494241871">
                  <div className="contact-item">
                    <div className="contact-icon">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <div className="contact-label">
                        <span>WhatsApp Soporte</span>
                      </div>
                      <div className="contact-value">
                        <span>249 424-1871</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div className="support-cta">
                <button id="openManualBtn" className="btn btn-primary">
                  Ver Manual de Bastones
                </button>
              </div>
            </div>
            <div className="support-visual">
              <img
                alt="image"
                src="/images/support-1500w.jpeg"
                className="soporte-image support-img"
              />
            </div>
          </div>
          <div className="soporte-container3">
            <div className="soporte-container4">
              <Script
                html={`<script>
(function(){
  // No JavaScript required for this compact grid layout.
})()
</script>`}
              ></Script>
            </div>
          </div>
        </div>
        <dialog id="manualModal" className="manual-dialog">
          <div className="dialog-header">
            <h2 className="section-subtitle">
              Manual de Configuración de Bastones
            </h2>
            <button id="closeManualBtn" className="close-btn">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M18 6L6 18M6 6l12 12"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </button>
          </div>
          <div className="dialog-body">
            <div className="manual-step">
              <strong>Paso 1:</strong>
              <span>
                {' '}
                Vincular el Bluetooth del dispositivo Android al bastón.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
            <div className="manual-step">
              <strong>Paso 2:</strong>
              <span>
                {' '}
                Configuración según modelo (HR4/5, True Test, Syno, AllFlex).
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
            <div className="manual-step">
              <strong>Paso 3:</strong>
              <span>
                {' '}
                Dentro de GESVET, presionar el botón de lectura y seleccionar el
                dispositivo.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
            <p className="section-content">
              Para configuraciones avanzadas (Modo HID, SPP o Slave), consulte
              directamente vía WhatsApp.
            </p>
          </div>
        </dialog>
      </section>
      <div className="soporte-container5">
        <div className="soporte-container6">
          <Script
            html={`<script>
(function(){
  // No JavaScript required for this professional grid layout as per specifications.
  // Using semantic HTML and CSS Grid for optimal performance and accessibility.
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer
        text={
          <Fragment>
            <span className="soporte-text18">Soporte</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="soporte-text19">Aplicacion</span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="soporte-text20">Home</span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="soporte-text21">Bluetooth</span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="soporte-text22">Soporte1</span>
          </Fragment>
        }
      ></Footer>
    </div>
  )
}

export default Soporte
